import { useEffect, useRef, forwardRef } from 'react'
import { DragOutlined } from '@ant-design/icons'

import { renderTranslation } from '../../../Helpers/GenericHelpers'
import { TranslationKeys } from '../../../Constants/TranslationKeys'
import { UiCodePIM, pubblcationsContainer, pubblcationsSectionId } from '../../../Constants/Configuration'
import { useAppSelector } from '../../../hooks'
import Pubblications from './Pubblications'
import RenderByProfileOptionWrapper from 'Components/Generic/RenderByProfileOptionWrapper'

function PubblicationGridLayout({ style, className, onMouseDown, onMouseUp, onTouchEnd, children, ...props }, ref) {
  const language = useAppSelector(state => state.present.language.value)
  const articleSelected = useAppSelector(state => state.present.articleDetail.articleSelected)
  const descBoxDomElementRef = useRef(null)
  const isQuantitiesFetched = articleSelected.fetchedQuantities
  const isImagesVisible = useAppSelector(state => state.present.configuration.isImagesVisible)
  const workspaceImagesVisible = useAppSelector(state => state.present.configuration.workspaceImagesVisible)

  useEffect(() => {
    if (isImagesVisible && workspaceImagesVisible) {
      const imageRef = descBoxDomElementRef.current
      if (imageRef) {
        descBoxDomElementRef && props.domElementsRefObserver && props.domElementsRefObserver.observe(imageRef)

        return () => {
          descBoxDomElementRef && props.domElementsRefObserver && props.domElementsRefObserver.unobserve(imageRef)
        }
      }
    }
  }, [props.domElementsRefObserver, descBoxDomElementRef, isImagesVisible, workspaceImagesVisible])

  useEffect(() => {
    //essential for first render to match container width
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'))
    }, 500)
  }, [])

  return (
    <RenderByProfileOptionWrapper sectionName={UiCodePIM}>
      <div
        id={pubblcationsSectionId}
        grid-data={props.datagrid}
        className={className + (!isQuantitiesFetched ? ' d-none' : '')}
        style={{ ...style }}
        ref={ref}
        onMouseDown={onMouseDown}
        onMouseUp={onMouseUp}
        onTouchEnd={onTouchEnd}
      >
        <div className='grid-layout-adjust-wrapper'>
          <div className='drag-handle-grid-container'>
            <DragOutlined />
          </div>
          <div className='diwa-container' ref={descBoxDomElementRef} id={pubblcationsContainer}>
            <div className={`label-drag`}>{renderTranslation(language, TranslationKeys.buttonPubbliSection)}</div>
            <Pubblications />
          </div>
        </div>
      </div>
    </RenderByProfileOptionWrapper>
  )
}

export default forwardRef(PubblicationGridLayout)
